<template>
  <div>
    <Breadcrumb :style="{ margin: '24px 0' }">
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>数据概览</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{ padding: '24px', minHeight: '280px', background: '#fff' }">
      <!-- {{title}} -->
      <div id="myChart" :style="{ width: '85%', height: '500px' }"></div>
    </Content>
  </div>
</template>
<style scoped></style>
<script>
import index from '@/assets/js/views/index/index';

export default {
  ...index,
};
</script>

